
import { AssessmentSection } from '@/types/assessment-types';

export const ASSESSMENT_SECTIONS: AssessmentSection[] = [
  {
    id: 'productCraft',
    title: 'Product Craft & Technical Excellence',
    description: 'Your product strategy, technical partnerships, and data-driven leadership'
  },
  {
    id: 'customerDiscovery',
    title: 'Customer Discovery & Understanding',
    description: 'Your customer insights and problem space mastery'
  },
  {
    id: 'researchDesign',
    title: 'Research & Design Mastery',
    description: 'Your research leadership and design excellence'
  },
  {
    id: 'marketImpact',
    title: 'Market & Business Impact',
    description: 'Your market understanding and business impact'
  },
  {
    id: 'productOperations',
    title: 'Product Operations & Team Leadership',
    description: 'Your process excellence and team leadership'
  },
  {
    id: 'industryImpact',
    title: 'Industry Impact & Influence',
    description: 'Your thought leadership and professional impact'
  }
];
